import { computed } from "vue";
import { useContractCreateStore } from "../contract-create-store";
import { usePublicStore } from "../public-store";
import type { ILoaderData } from "nlb-buy-go-library";

export function useLoaderData() {
    const contractCreateStore = useContractCreateStore();
    const publicStore = usePublicStore();

    const ViewLoaderData = computed<ILoaderData>({
        get: () => ({
            isDataLoading: contractCreateStore.AppState.ProcessData.isViewDataLoading,
            loaderType: contractCreateStore.AppState.ProcessData.loaderType
        }),
        set: (newValues: ILoaderData) => {
            contractCreateStore.AppState.ProcessData.isViewDataLoading = newValues.isDataLoading;
            contractCreateStore.AppState.ProcessData.loaderType = newValues.loaderType;
        }
    });

    const ViewLoaderPublicData = computed<ILoaderData>({
        get: () => ({
            isDataLoading: publicStore.PublicState.FlowData.isViewDataLoading,
            loaderType: ""
        }),
        set: (newValues: ILoaderData) => {
            publicStore.PublicState.FlowData.isViewDataLoading = newValues.isDataLoading;
        }
    });

    const AppLoaderPublicData = computed<ILoaderData>({
        get: () => ({
            isDataLoading: publicStore.PublicState.FlowData.isAppDataLoading,
            loaderType: ""
        }),
        set: (newValues: ILoaderData) => {
            publicStore.PublicState.FlowData.isAppDataLoading = newValues.isDataLoading;
        }
    });

    const AppLoaderData = computed<ILoaderData>({
        get: () => ({
            isDataLoading: contractCreateStore.AppState.ProcessData.isAppDataLoading,
            loaderType: ""
        }),
        set: (newValues: ILoaderData) => {
            contractCreateStore.AppState.ProcessData.isAppDataLoading = newValues.isDataLoading;
        }
    });

    return { ViewLoaderData, ViewLoaderPublicData, AppLoaderData, AppLoaderPublicData };
}
